/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/


import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from '@msdyn365-commerce-modules/utilities';
import React from 'react';

export interface IItemAddedToCartDialogResources {
    viewCartButtonText: string;
    orderTemplateCloseButtonText: string;
    itemAddedToCartHeaderItemOneText: string;
    itemAddedToCartHeaderItemFormatText: string;
    itemAddedToCartHeaderMessageText: string;

    freePriceText: string;
    originalPriceText: string;
    currentPriceText: string;
}

// export interface IItemAddedToCartDialogData {
//     product: SimpleProduct;
//     productPrice: ProductPrice;
//     quantity: number;
// }

export interface IItemAddedToCartDialogProps  {
    className: string;
    alternateItem: boolean;
    //dialogStrings: IItemAddedToCartDialogResources;
    modalHeader: string;
    modalBodyText: string;
    modalOpen: boolean | undefined;
    quantity: number;
    onClose(): void;
    // onClosePopup(): void;
    _addItemToCartCustom(quantity:number): void;
    onNoClick(): void;
}

export const ConfirmAddedToCartDialog = (dialogProps: IItemAddedToCartDialogProps) => {
    const {

        className,

        modalOpen

    } = dialogProps;


    const close: () => void = () => {
        dialogProps.onClose();
    };

    const _addItemToCartCustom:() => void = () => {
        dialogProps._addItemToCartCustom(dialogProps.quantity);
    };

    const onNoClick:() => void = () => {
        dialogProps.onNoClick();
    };

    // const closePopup: () => void = () => {
    //     dialogProps.onClosePopup();
    // };

    return (
        <Modal isOpen={modalOpen} className={`${className}`} toggle={close}>
            <ModalHeader className={`${className}__dialog__header`} toggle={close}>
                <span>{dialogProps.modalHeader}</span>
            </ModalHeader>
            <ModalBody className={`${className}__dialog__body`}>
                <div className={`${className}__dialog__content`}>
                    {dialogProps.modalBodyText}
                </div>
            </ModalBody>
            <ModalFooter
                className={`${className}__dialog__footer`}
            >
                {!dialogProps.alternateItem ?(<div><Button
                    className={`${className}__dialog__view-cart-button`}
                    title={`Yes`} onClick={_addItemToCartCustom}

                >
                   Yes
                </Button>
                <Button
                className={`${className}__dialog__continue-shopping`}
                title={!dialogProps.alternateItem ? 'No': 'Close'}
                onClick={onNoClick}
            >
             {!dialogProps.alternateItem ? 'No': 'Close'}
            </Button>
                </div>):(<Button
                    className={`${className}__dialog__continue-shopping`}
                    title={'Close'}
                    onClick={close}
                >
                 Close
                </Button>)}

            </ModalFooter>
        </Modal>
    );
};
